module.exports = __webpack_public_path__ + "img/1602400482.aae318b2.png";